import type { ViewportCoordinate } from "@/model/coordinates";

const scrollDistance = 20;

export function scrollNearBoarder(pos: ViewportCoordinate) {
  const el = document.documentElement;
  const scrollX = check(pos.x, el.scrollLeft, el.clientWidth);
  const scrollY = check(pos.y, el.scrollTop, el.clientHeight);
  if (scrollX !== undefined || scrollY !== undefined) {
    el.scrollTo({ left: scrollX, top: scrollY });
  }

  function check(pos: number, scroll: number, size: number) {
    let d = scrollDistance - pos;
    if (d > 0) {
      return scroll - d;
    }
    d = scrollDistance - size + pos;
    if (d > 0) {
      return scroll + d;
    }
  }
}
